import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useDeleteOperationMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { useNotifyMessages } from 'api/helpers/useNotifyMessages';

export const useDeleteOperation = () => {
  const [handle, { loading, error: apolloError }] =
    useDeleteOperationMutation();

  const notifyMessage = useNotifyMessages();

  const error = useError(apolloError);

  const deleteOperation = useCallback(
    async (operationId: string, versionNumber: number) => {
      const res = await handle({
        variables: {
          id: operationId,
          versionNumber,
        },
      });
      if (res.data?.deleteOperation?.messages) {
        notifyMessage(res.data.deleteOperation.messages);
      }

      return res.data?.deleteOperation?.data;
    },
    [handle, notifyMessage]
  );

  return {
    loading,
    error,
    deleteOperation,
  };
};
